export default "__VITE_ASSET__BZ5DFG5z__"